import { render, staticRenderFns } from "./goods-image.vue?vue&type=template&id=3ca1791d&scoped=true"
import script from "./goods-image.vue?vue&type=script&lang=js"
export * from "./goods-image.vue?vue&type=script&lang=js"
import style0 from "./goods-image.vue?vue&type=style&index=0&id=3ca1791d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1791d",
  null
  
)

export default component.exports